import React from 'react'

import TableCompanyCategories from '../../../components/table/companies/TableCompanyCategories'

const CompanyCategoriesPage = () => {
  return <TableCompanyCategories />
}

export default CompanyCategoriesPage
